import { css } from 'styled-components';
import { getColorPalette, ThemedFunctor } from '@doveit/lego';

export const icon: ThemedFunctor = ({
  theme,
  $color,
}) => css`
  ${$color && `color: ${getColorPalette(theme, $color)};`}
`;
